import { takeLatest, put, call } from 'redux-saga/effects';

import { listDespesaDiretaCadastro } from '../service';
import {
  TABLE_DESPESA_DIRETA_CADASTRO,
  TABLE_DESPESA_DIRETA_CADASTRO_PENDING,
  TABLE_DESPESA_DIRETA_CADASTRO_SUCCESS,
  TABLE_DESPESA_DIRETA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListDespesaDiretaCadastro(action) {
  yield put({ type: TABLE_DESPESA_DIRETA_CADASTRO_PENDING })

  try {
    const table = yield call(listDespesaDiretaCadastro, action.args)
    yield put({ type: TABLE_DESPESA_DIRETA_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_DESPESA_DIRETA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListDespesaDiretaCadastro() {
  yield takeLatest(TABLE_DESPESA_DIRETA_CADASTRO, sagaListDespesaDiretaCadastro)
}